import axios from 'axios'
import get from 'lodash/get'
import { REACT_APP_GOOGLE_API_KEY } from '../../config/env'

export const getGoogleAddress = async (params) => {
  // console.log(params.lat)
  try {
    return await axios
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${params.lat},${params.lng}&key=${REACT_APP_GOOGLE_API_KEY}&language=th`,
      )
      .then((response) => {
        return get(response, 'data', '')
      })
  } catch (error) {
    return error
  }
}
